import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import classnames from 'classnames';
import { createRoute } from 'lib/util';

import { getFirstImage } from 'lib/assets/assets_helpers';
import noimg from 'assets/img/noimg.gif';
import * as DF from 'fixedassets/components/detail/field';

class AssetDetailGeneral extends Component {
  state = {
    message: '',
  };
  render = () => {
    const img = getFirstImage(this.props.asset._files) || noimg;
    const { t, permissions } = this.props;
    const { out, _employee, _asset_level } = this.props.asset;
    const img_employee = _employee && _employee.imgUrl ? _employee.imgUrl : noimg;
    const diffDates = (date1, date2) => {
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1 + '';
      return diffDays;
    };
    const out_role_to_acept = out && out.role_to_acept ? out.role_to_acept : '';

    return (
      <Form.Section title={this.props.t('assets.section.in_out')}>
        <div className="row">
          <div className="col-sm-12">
            <div className="row">
              <DF.Text label={'assets.fields.number'} value={this.props.asset.number} />
              <DF.Text label={'assets.fields.name'} value={this.props.asset.name} />
              <DF.Text
                label={'assets.fields.employee'}
                value={_employee ? _employee.name + ' ' + _employee.lastname : ''}
              />
              <DF.Text
                label={'assets.fields.asset_level'}
                value={_asset_level ? _asset_level.key + ' - ' + _asset_level.name : ''}
              />
            </div>

            {_asset_level ? (
              <div className="row">
                <DF.Text
                  label={'asset_level.fields.can_withdrawn'}
                  value={_asset_level.can_withdrawn ? 'Si' : 'No'}
                />
                <DF.Text
                  label={'asset_level.fields.role_to_acept'}
                  value={_asset_level.role_to_acept ? _asset_level.role_to_acept.name : ''}
                />
                <DF.Text label={'asset_level.fields.max_time'} value={_asset_level.max_time} />
                <DF.Text
                  label={'asset_level.fields.message_required'}
                  value={_asset_level.message_required ? 'Si' : 'No'}
                />
              </div>
            ) : null}
            <div className="row">
              <div className="col-sm-12">
                {/* Is In */}
                {permissions['acl.ins_outs.in'] && (!out || (out && !out.isOut)) ? (
                  <div className="row">
                    <DF.Text
                      label={'assets.fields.out.isOut'}
                      value={t('assets.fields.out.is_in')}
                    />
                    <p className="col-sm-1">Acción:</p>
                    <Form.Link
                      to={createRoute(
                        this.props.company.id,
                        this.props.subcompany.id,
                        'assets/' + this.props.asset.id + '/detail'
                      )}
                      className={classnames('btn btn-primary text-center mr-3 mb-5')}
                      onClick={(e) => {
                        this.props.OutputAsset({ message: this.state.message });
                      }}
                    >
                      {this.props.t('assets.fields.out.get_out')}
                    </Form.Link>
                    <div className="clearfix" />
                    <div className="col-sm-12"></div>
                    <div className="col-sm-12">
                      <Form.FieldTextArea
                        // error={(isSubmitted && errors.description) || {}}
                        name={'message'}
                        label={t('assets.fields.out.message')}
                        handleChange={(e) => this.setState({ message: e.target.value })}
                        t={t}
                        value={this.state.message}
                      />
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </div>
                ) : permissions['acl.ins_outs.resolve'] &&
                  out &&
                  out.isOut &&
                  !out.outAuthorized ? ( // out not authorized yet
                  <div className="row">
                    <div className="col-md-12">
                      <p>Accion:</p>
                      <Form.Link
                        to={createRoute(
                          this.props.company.id,
                          this.props.subcompany.id,
                          'assets/' + this.props.asset.id + '/detail'
                        )}
                        className={classnames('btn btn-primary text-center mr-3 mb-5')}
                        onClick={(e) => {
                          this.props.AceptOutput();
                        }}
                      >
                        {this.props.t('assets.fields.out.acept_output')}
                      </Form.Link>
                      <div className="clearfix" />
                    </div>
                    <div className="col-md-12 mt-3">
                      <Form.Link
                        to={createRoute(
                          this.props.company.id,
                          this.props.subcompany.id,
                          'assets/' + this.props.asset.id + '/detail'
                        )}
                        className={classnames('btn btn-primary text-center mr-3 mb-5')}
                        onClick={(e) => {
                          this.props.RejectOutput();
                        }}
                      >
                        {this.props.t('assets.fields.out.reject_output')}
                      </Form.Link>
                      <div className="clearfix" />
                    </div>
                    <DF.Text
                      label={'assets.fields.out.isOut'}
                      value={t('assets.fields.out.needs_authorization')}
                    />
                    <DF.DateTime label={'assets.fields.out.createdAt'} value={out.createdAt} />
                    <DF.Text
                      label={'assets.fields.out._user_request'}
                      value={
                        out._user_request.name +
                        ' ' +
                        out._user_request.lastname +
                        ' (' +
                        out._user_request.email +
                        ')'
                      }
                    />
                    <DF.Text label={'assets.fields.out.message'} value={out.message} />
                  </div>
                ) : permissions['acl.ins_outs.out'] ? ( // out authorized
                  <div className="row">
                    <div className="col-md-12">
                      <p>Accion:</p>
                      <Form.Link
                        to={createRoute(
                          this.props.company.id,
                          this.props.subcompany.id,
                          'assets/' + this.props.asset.id + '/detail'
                        )}
                        className={classnames('btn btn-primary text-center mr-3 mb-5')}
                        onClick={(e) => {
                          this.props.InputAsset();
                        }}
                      >
                        {this.props.t('assets.fields.out.get_in')}
                      </Form.Link>
                      <div className="clearfix" />
                    </div>
                    <DF.Text
                      label={'assets.fields.out.isOut'}
                      value={t('assets.fields.out.is_out')}
                    />
                    <DF.DateTime label={'assets.fields.out.createdAt'} value={out.createdAt} />
                    <DF.Text
                      label={'assets.fields.out._user_request'}
                      value={
                        out._user_request.name +
                        ' ' +
                        out._user_request.lastname +
                        ' (' +
                        out._user_request.email +
                        ')'
                      }
                    />
                    <DF.Text
                      label={'assets.fields.out._user_authorized'}
                      value={
                        out._user_authorized.name +
                        ' ' +
                        out._user_authorized.lastname +
                        ' (' +
                        out._user_authorized.email +
                        ')'
                      }
                    />
                    <DF.DateTime label={'assets.fields.out.outDate'} value={out.outDate} />
                    <DF.Text
                      label={'assets.fields.out.time_out'}
                      value={diffDates(new Date(out.outDate), new Date())}
                    />
                    <DF.Text label={'assets.fields.out.message'} value={out.message} />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* <div className="col-sm-4 col-md-4 col-xl-2 text-center"> */}
          <div className="col-6 text-center">
            {img && img.url ? (
              <a href={img.url} target="__brank">
                <img src={img.url} style={{ maxWidth: '70%', maxHeight: '200px' }} />
              </a>
            ) : (
              <img src={img} style={{ width: '70%' }} />
            )}
            <p>{t('assets.fields.img_asset')}</p>
          </div>

          <div className="col-6 text-center">
            {_employee && _employee.imgUrl ? (
              <a href={img_employee} target="__brank">
                <img src={img_employee} style={{ maxWidth: '70%', maxHeight: '200px' }} />
              </a>
            ) : (
              <img src={img_employee} style={{ width: '70%' }} />
            )}
            <p>{t('assets.fields.img_employee')}</p>
          </div>
        </div>
      </Form.Section>
    );
  };
}

export default translate()(AssetDetailGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailInsAndOuts.js